// Widget scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidgetSEOText from './js/widgets/cardWidgetSEOText.js';
import cardWidgetBanner from './js/widgets/cardWidgetBanner.js';
import cardWidgetHotButtons from './js/widgets/cardWidgetHotButtons.js';
import swiperWidgetSlideshow from './js/widgets/swiperWidgetSlideshow.js';
import videoWidget from './js/widgets/videoWidget.js';
import cssSponsors from './js/widgets/cssSponsors.js';


// Custom theme scripts
import './js/localjs.js';



// Initialize homepage widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    swiperWidget();   
    cardWidgetSEOText();
    cardWidgetBanner();
    cardWidgetHotButtons();
    cssSponsors();     
  });
  
  $(window).load(function() {
    if (!$('#body').hasClass('eventsMode')) {
      swiperWidgetSlideshow();
    } else {
      videoWidget();
    }
  });
}